define([
	"dojo/_base/declare",
	"csi/image/_base",
	"csi/printUtil",
	"csi/property/Widget"
], function(declare,csiImage,printUtil,PropertyWidget) {

	return declare(PropertyWidget, {
		/**
		 * @override
		 * Return fixed height for size label image based on its HeightImage attribute
		 */
		_getDefaultImageHeight: function(bFixed) {
			const sizeLabel = this.getImageContainer();

			if (this._getSizeLabelImageWidthToHeightRatio(sizeLabel)) {
				// HeightImage is measured in cm, so multiply by 10
				return printUtil.convertMMtoPX(sizeLabel.HeightImage * 10);
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Return fixed width for size label image based on its HeightImage attribute
		 */
		_getDefaultImageWidth: function(bFixed) {
			const sizeLabel = this.getImageContainer();
			const ratio = this._getSizeLabelImageWidthToHeightRatio(sizeLabel);
			
			if (ratio) {
				return Math.round(printUtil.convertMMtoPX(sizeLabel.HeightImage * 10) * ratio);
			}

			return this.inherited(arguments);
		},
		
		/**
		 * Return ratio of size label default image's width to height
		 * @param {Node} sizeLabel
		 * @return {number}
		 */
		_getSizeLabelImageWidthToHeightRatio: function(sizeLabel) {
			if (sizeLabel && sizeLabel.HeightImage && !this.propertyImageHeight) {
				const image = this.cacheView.get(csiImage.getDefaultImage(sizeLabel));
				if (image) {
					return image.Width / image.Height;
				}
			}
			
			return 0;
		}
	});
});
